/* eslint-disable no-mixed-operators */
/* eslint-disable no-console */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';

import styles from './first-step.css';

class VideoShow extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
        ]);
    }
    componentDidMount () {
        
    }
    shouldComponentUpdate (nextProps, nextState) {
        if (nextProps.videoSrc !== this.props.videoSrc){
            return true;
        }
        return false;
    }
    render () {
        const {videoSrc, onClick} = this.props;
        return (
            <div className={styles.modalBodyVideoContainer}>
                <video
                    className={styles.modalBodyVideo}
                    src={videoSrc}
                    preload="auto"
                    controls
                    playsInline
                    x-webkit-airplay="allow"
                    onClick={onClick}
                    disablepictureinpicture="true"
                    controlsList="nodownload"
                />
            </div>
        );
    }
}

VideoShow.propTypes = {
    videoSrc: PropTypes.string,
    onClick: PropTypes.func
};

export default VideoShow;
